enum EndpointsErrorHandling {
  Unauthorized = '/unauthorized',
  Wildcard = '*',
}

export default EndpointsErrorHandling;
